import { lerp } from '@/utils/lerp';
import { OrbitControls } from '@react-three/drei';
import { useFrame, useThree } from '@react-three/fiber';
import { useEffect } from 'react';
import { useExperienceStore } from '../../store';
// import { MathUtils } from 'three';
import { useRef } from 'react';
import { clamp } from 'three/src/math/MathUtils';
// import { useStartTyping } from 'react-use';

export function CameraController() {
  const { gl, camera } = useThree();

  const { currentState, exploreState, activeIndexes } = useExperienceStore(
    (state) => ({
      currentState: state.currentState,
      exploreState: state.exploreState,
      activeIndexes: state.activeIndexes,
    })
  );

  const wheelDelta = useRef(0);

  // Update the camera positin with a simple lerp based on the scenes
  useFrame(() => {
    let lerpingZ = 28;
    const delta = wheelDelta.current;

    if (currentState === 'explore') {
      switch (exploreState) {
        case 'orb':
          lerpingZ = lerp(camera.position.z, 30 + delta, 0.02);
          break;
        case 'cluster':
          switch (activeIndexes.length) {
            case 1:
              lerpingZ = lerp(camera.position.z, 40 + delta, 0.02);
              break;
            case 2:
              lerpingZ = lerp(camera.position.z, 50 + delta, 0.02);
              break;
            case 3:
              lerpingZ = lerp(camera.position.z, 60 + delta, 0.02);
              break;
            default:
              lerpingZ = lerp(camera.position.z, 35 + delta, 0.02);
              break;
          }
          break;
        default:
          break;
      }
    } else {
      lerpingZ = lerp(camera.position.z, 30 + delta, 0.02);
    }

    camera.position.z = lerpingZ;
  });

  /**
   * @TODO This causes a shift/distortion effect in React 18
   * Find a way to animate the camera but not retrigger the whole scene!
   */
  // useEffect(() => {
  //   console.log('offending effect is now firing');
  //   console.log({ size, camera, currentState });
  //   if (
  //     currentState === 'intro' ||
  //     currentState === 'start' ||
  //     currentState === 'explore'
  //   ) {
  //     const fov = 50;
  //     const planeAspectRatio = 16 / 9;
  //     const aspect = size.width / size.height;
  //     const cameraHeight = Math.tan(MathUtils.degToRad(fov / 2));
  //     const ratio = aspect / planeAspectRatio;
  //     const newCameraHeight = cameraHeight / ratio;
  //     // @TODO IT SEEMS LIKE THIS LINE CAUSES THE ERROR
  //     // SHOULD WE LERP TO THE NEW VALUE? OR USE FRAMER MOTION VALUE API?
  //     // @ts-expect-error fov exists
  //     // camera.fov = MathUtils.radToDeg(Math.atan(newCameraHeight)) * 2;
  //   }
  // }, [currentState]);

  useEffect(() => {
    let delta = 0;
    const onScroll = (e: globalThis.WheelEvent) => {
      delta += e.deltaY / 250;

      wheelDelta.current = clamp(delta, -10, 20);
    };
    window.addEventListener('wheel', onScroll);

    return () => window.removeEventListener('wheel', onScroll);
  }, []);

  return (
    <OrbitControls
      enabled={false}
      autoRotate={false}
      enablePan={false}
      minDistance={10}
      maxDistance={70}
      zoomSpeed={0.05}
      dampingFactor={0.001}
      // maxDistance={60}
      target={[0, 0, 0]}
      args={[camera, gl.domElement]}
      makeDefault
    />
  );
}
